// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PROGRESS_CLEAR_WEIGHINGS,
} from './constants';

export function clearWeighings() {
  return {
    type: PROGRESS_CLEAR_WEIGHINGS,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROGRESS_CLEAR_WEIGHINGS:
      return {
        ...state,
        weighings: null
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/progress/redux/clearWeighings.js